import React, { FC } from 'react';
import MultiEmailComponentAntdV4 from '../MultiEmailComponent/MultiEmailComponentAntdV4';

const BuyerSupplierEmailNotificationFields: FC<any> = (): React.ReactElement => {
	return (
		<>
			<MultiEmailComponentAntdV4
				fieldProps={{
					preserve: false,
					tooltip:
						'These supplier email addresses will be notified whenever a work order is created/updated.You can enter multiple emails seperated by comma',
					label: 'Work order notifications sent to',
					name: 'workOrdersRoutedTo',
				}}
			/>
			<MultiEmailComponentAntdV4
				fieldProps={{
					preserve: false,
					tooltip:
						'These supplier email addresses will be notified when you request for a proposal.You can enter multiple emails seperated by comma',
					label: 'Proposal notifications sent to',
					name: 'requestForProposalRoutedTo',
				}}
			/>
		</>
	);
};

export default BuyerSupplierEmailNotificationFields;
